import { modalTypes } from "./types/modal.types";

export const toggleModal = (contextData = { type: {}, data: {} }) => {
    return dispatch => {
        return dispatch({
            type: modalTypes.TOGGLE_MODAL,
            payload: contextData
        });
    };
};

export const closeModal = () => {
    return dispatch => {
        return dispatch({
            type: modalTypes.CLOSE_MODAL
        });
    };
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/actions/modal.actions.js